import { getOPCO, getOpcoRegion } from "./helper";

const opco = getOPCO()
const region = getOpcoRegion()

export const FOUR_G_SERVICE = '_4Gservice';
export const FOUR_G = '4G coverage';
export const FIVE_G = '5G coverage';
export const TWO_G = '2G coverage';
export const THREE_G = '3G coverage';
export const CONTACT_US = 'Contact Us';
export const AIRTEL_SHOPS = 'Airtel Shops';
export const DEALERS = 'Dealers';
export const SERVICE_EXP = 'Our Service Experience';
export const AIRTEL_MONEY_LOANS = 'Airtel Money Loans';
export const ROUTES = {
    'CONTACT_US': '/contact-us',
    'AIRTEL_SHOPS': '/store_finder/airtel_shop',
    'DEALERS': '/store_finder/dealers',
    'SERVICE_EXP': '/give_your_feedback',
    'AIRTEL_MONEY_LOANS': '/more-airtel-money'
}
export const HEADER_URL = `/sites/api/region/header/${region}`;
export const FOOTER_URL = `/sites/api/region/footer/${region}`;
export const FOOTER_URL_OLD = `/cms/webpage/activePackage?opco=${opco}&pageUrl=languagePrefix/website-footer-config`;
export const HEADER_URL_OLD = `/cms/webpage/activePackage?opco=${opco}&pageUrl=languagePrefix/website-headers-config`;

export const HOME_PAGE_URL = `/cms/webpage/activePackage?opco=${opco}&pageUrl=languagePrefix/website-homepage-config`;
export const HOME_PAGE_URL_V2 = `/cms/webpage/activePackage?opco=${opco}&pageUrl=languagePrefix/website-homepage-config-v2`;
export const ORP_TRANSLATION = `/cms/webpage/activePackage?opco=${opco}&pageUrl=languagePrefix/orp-translation`;
export const OPEN_NETWORK_TRANSLATE = `cms/webpage/activePackage?opco=${opco}&pageUrl=/network-translation`;
export const FEEDBACK_TRANSLATE = `cms/webpage/activePackage?opco=${opco}&pageUrl=/feedback-translation`;
export const CORPORATE_POSTPAID_TRANSLATE = `cms/webpage/activePackage?opco=${opco}&pageUrl=/corporate-postpaid`;
export const FEEDBACK_FORM_SCHEMA = `cms/webpage/activePackage?opco=${opco}&pageUrl=languagePrefix/get-feedback-form-schema`;


export const FOOTER = "footer";
export const HEADER = "header";
export const TRANSLATION = "translation";
export const HOME_PAGE = "homePage";
export const GET = "get";
export const cdnImageNew = `https://cdn-webportal.airtelstream.net/website/${process.env.REACT_APP_COUNTRY}/assets/images/new`;
export const cdnImage = `https://cdn-webportal.airtelstream.net/website/${process.env.REACT_APP_COUNTRY}/`;
export const FOOTER_TRANSLATION_URL = `cms/webpage/activePackage?opco=${opco}&pageUrl=languagePrefix/footer-translation`;
export const FOOTER_TRANSLATION = "footer-translation";
export const LEAD_STATUS_TRANSLATION = `cms/webpage/activePackage?opco=${opco}&pageUrl=languagePrefix/lead-status-translation`;
export const SOMETHING_WENT_WRONG = "Something Went Wrong!"
export const META_TAGS_URL = `cms/webpage/activePackage?opco=${opco}&pageUrl=/meta-data-config`;
export const META_TAGS = 'meta-data';
export const HBB_MSISDN_CHECK = 'HBB_MSISDN_CHECK';
export const LANGUAGE_PREFIX = 'languagePrefix'
export const LOADER_TRANSLATION_URL = `cms/webpage/activePackage?opco=${opco}&pageUrl=languagePrefix/loader-translation`;
export const LOADER_TRANSLATION = `loader-translation`;
export const THANKYOU_NOTE = "Thank you for reaching out"

export const APP_TEXT = 'app'
export const CH_TEXT = 'ch'
export const BUNDLE_PURCHASE = 'BUNDLE PURCHASE'
export const BROADBAND_RECHARGE = 'Broadband Recharge'
export const HBB_BUNDLE = 'hbb_bndl'
export const AIRTIME = 'airtime'
export const OPCO = "opco";
export const NEW_THEME = "newTheme";
export const FTTX = "FTTX";
export const GEOLOCATION_NOT_SUPPORTED = "Geolocation is not supported";